/* ==========================================================================
   WSQ Mara Bird Spotter — interactivity
   Renders the filterable grid from the static JSON asset, handles tabs,
   card expand/collapse, and the Spotter's Corner form. No external libs.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.wsq-birds');

  /* ---------- Pagination (keeps a 60+ card grid fast) ---------- */
  var PAGE_SIZE = 24;
  var visibleLimit = PAGE_SIZE;
  var lastMatched = 0;
  var loadMoreEl = null;
  function syncLoadMore(total) {
    if (!loadMoreEl) return;
    var more = total - visibleLimit;
    if (more > 0) { loadMoreEl.style.display = ''; loadMoreEl.textContent = 'Load more birds (' + more + ' more)'; }
    else { loadMoreEl.style.display = 'none'; }
  }
  if (!root) return;

  var dataUrl = root.getAttribute('data-json');
  /* plain internal link — NO utm_* (they'd reset GA4's channel to mara_birds_page/cta and wreck the
     true SEO/paid/direct attribution). Bird-driven leads = GA4 `plan_safari` event + session landing_page. */
  var contactUrl = root.getAttribute('data-contact') || '/pages/contact-us';

  /* The 6 tile definitions — colours are fixed per the build spec (§4). */
  var TILES = [
    { key: 'zone',       label: 'Zone',        icon: 'ti-map-pin', bg: '#085041', ic: '#9FE1CB', tc: '#E1F5EE' },
    { key: 'hunts',      label: 'Hunts',       icon: 'ti-paw',     bg: '#854F0B', ic: '#FAC775', tc: '#FAEEDA' },
    { key: 'spot_from',  label: 'Spot from',   icon: 'ti-car',     bg: '#185FA5', ic: '#B5D4F4', tc: '#E6F1FB' },
    { key: 'best_time',  label: 'Best time',   icon: 'ti-sun',     bg: '#3B6D11', ic: '#C0DD97', tc: '#EAF3DE' },
    { key: 'rarity',     label: 'In the Mara', icon: 'ti-star',    bg: '#534AB7', ic: '#CECBF6', tc: '#EEEDFE' },
    { key: 'photography',label: 'Photography', icon: 'ti-camera',  bg: '#993C1D', ic: '#F5C4B3', tc: '#FAECE7' }
  ];

  /* IUCN → traveller-facing framing (§5). LC shows no badge. */
  var IUCN = {
    NT: 'Watch closely',
    VU: 'Special sighting',
    EN: 'Rare privilege',
    CR: 'Extraordinary encounter'
  };

  var CHALLENGE = ['', 'Easy spotter', 'Casual spotter', 'Advanced spotter', 'Expert spotter', 'Specialist'];

  /* Chips shown on the compact grid card — 3 most traveller-relevant facts. */
  var CHIPS = [
    { key: 'zone',      icon: 'ti-map-pin' },
    { key: 'best_time', icon: 'ti-sun' },
    { key: 'rarity',    icon: 'ti-star' }
  ];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- Analytics ----------
     The page's gtag stub doesn't forward custom events, but the live Google Tag is bound to
     window.dataLayer, so a gtag-format push there (with send_to) reaches GA4 G-2RSSB7KG7Z.
     track() is the single entry point for every interaction event on this page. */
  var GA4_ID = 'G-2RSSB7KG7Z';
  function gtagPush() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }
  function track(name, params) {
    try {
      var p = params || {};
      p.send_to = GA4_ID;
      gtagPush('event', name, p);
    } catch (e) {}
  }

  /* ---------- Seasonality ---------- */
  var MON = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH_NOTES = {
    1:  'Northern-winter migrants are in — rollers, harriers, falcons, storks. Green plains, big skies, fewer vehicles.',
    2:  'Migrants still present and resident birds breeding. Lush, photogenic, and quiet on the tracks.',
    3:  'Long rains begin — emerald plains, breeding plumage, and the last Palearctic migrants before they head north.',
    4:  'Green season — dramatic skies and departing migrants. Fewer crowds, lower prices, birds at their best.',
    5:  'Tail of the rains — resident birds breeding; migrants gone. The Mara at its greenest and quietest.',
    6:  'Dry season opens — grass thinning, visibility improving. Resident raptors and waterbirds become easy.',
    7:  'The Great Migration arrives — river crossings begin, and vultures, Marabou and eagles gather at carcasses.',
    8:  'Peak migration — maximum scavenger spectacle and superb all-round game and bird visibility.',
    9:  'Migration still strong, dry and clear — excellent for raptors and plains birds. First migrant waders return.',
    10: 'End of the dry season — crossings tail off as the first Palearctic migrants (bee-eaters, waders) trickle in.',
    11: 'Short rains and the migrant arrival — rollers, harriers, falcons and storks pour in. Fresh green, dramatic light.',
    12: 'Full migrant season and festive green — Amur Falcons, harriers and European Roller in. Lush and birdy.'
  };
  function monthsLabel(ms) {
    if (!ms || ms.length >= 12) return 'Year-round';
    var s = ms.slice().sort(function (a, b) { return a - b; });
    var gapStart = 0, gapLen = 0;
    for (var i = 0; i < s.length; i++) {
      var diff = (s[(i + 1) % s.length] - s[i] + 12) % 12; if (diff === 0) diff = 12;
      if (diff > gapLen) { gapLen = diff; gapStart = (i + 1) % s.length; }
    }
    return MON[s[gapStart]] + '–' + MON[s[(gapStart - 1 + s.length) % s.length]];
  }
  function seasonStrip(months) {
    var present = {}; (months || []).forEach(function (m) { present[m] = 1; });
    var wrap = el('span', 'wsq-season-strip');
    for (var m = 1; m <= 12; m++) {
      var c = el('span', 'wsq-season-cell' + (present[m] ? ' on' : ''));
      c.title = MON[m];
      wrap.appendChild(c);
    }
    return wrap;
  }
  function inMonth(bird, month) {
    if (!month) return true;
    var ms = bird.months || [];
    if (!ms.length) return true;
    return ms.indexOf(month) !== -1;
  }

  function tileEl(bird, def, compact) {
    var t = el('div', 'wsq-tile');
    var i = el('i', 'ti ' + def.icon);
    i.style.color = def.bg; /* signature colour lives in the icon only (calm style) */
    i.setAttribute('aria-hidden', 'true');
    t.appendChild(i);
    t.appendChild(el('p', 'wsq-tile-label', def.label));
    t.appendChild(el('p', 'wsq-tile-value', bird.tiles[def.key] || '—'));
    return t;
  }

  function iucnBadge(code) {
    if (!code || !IUCN[code]) return null;
    var b = el('span', 'wsq-iucn');
    b.appendChild(el('i', 'ti ti-eye'));
    b.appendChild(document.createTextNode(' ' + IUCN[code]));
    return b;
  }

  function confColor(s) {
    if (s >= 80) return '#2c5440';
    if (s >= 60) return '#4C8A1A';
    if (s >= 40) return '#B08435';
    if (s >= 20) return '#b4541f';
    return '#993C1D';
  }
  function confidenceEl(score, label, compact) {
    score = Math.max(0, Math.min(100, score || 0));
    var filled = Math.round(score / 20);
    var wrap = el('div', 'wsq-confidence' + (compact ? ' wsq-bird-conf' : ''));
    wrap.style.setProperty('--conf-color', confColor(score));
    var top = el('div', 'wsq-conf-top');
    top.appendChild(el('span', 'wsq-conf-label', 'Spotting confidence'));
    var bars = el('span', 'wsq-conf-bars');
    for (var i = 1; i <= 5; i++) bars.appendChild(el('span', 'wsq-conf-bar' + (i <= filled ? ' on' : '')));
    top.appendChild(bars);
    var num = el('span', 'wsq-conf-num');
    num.appendChild(document.createTextNode(String(score)));
    num.appendChild(el('small', null, '/100'));
    top.appendChild(num);
    wrap.appendChild(top);
    /* label always on its own line below the score row, so cards stay the same height
       whether the label is short ("Very likely") or long ("Almost guaranteed") */
    if (label) wrap.appendChild(el('span', 'wsq-conf-text', label));
    if (!compact) wrap.appendChild(el('p', 'wsq-conf-src', 'Based on recent sightings near the Maasai Mara'));
    return wrap;
  }

  function birdCard(bird, order) {
    var card = el('article', 'wsq-bird-card');
    card.setAttribute('data-tab', bird.tab);
    card.setAttribute('data-months', (bird.months || []).join(','));
    card.setAttribute('data-order', String(order || 0));
    card.setAttribute('data-seasonal', bird.seasonality === 'migrant' ? '1' : '0');
    card.setAttribute('data-name', ((bird.common_name || '') + ' ' + (bird.scientific_name || '')).toLowerCase());
    card.setAttribute('tabindex', '0');
    card.setAttribute('role', 'button');
    card.setAttribute('aria-expanded', 'false');

    var illo = el('div', 'wsq-bird-illo');
    illo.style.background = bird.card_colour || '#E1F5EE';
    if (bird.photo) {
      var img = document.createElement('img');
      img.className = 'wsq-bird-photo';
      img.src = bird.photo;
      img.alt = bird.common_name;
      img.loading = 'lazy';
      if (bird.photo_focus) img.style.objectPosition = bird.photo_focus;
      illo.appendChild(img);
      if (bird.photo_credit) illo.appendChild(el('span', 'wsq-photo-credit', bird.photo_credit));
    } else {
      var feather = el('i', 'ti ti-feather');
      feather.style.color = bird.card_icon_colour || '#085041';
      feather.setAttribute('aria-hidden', 'true');
      illo.appendChild(feather);
    }
    card.appendChild(illo);

    var info = el('div', 'wsq-bird-info');
    var head = el('div');
    head.appendChild(el('h3', null, bird.common_name));
    head.appendChild(el('p', 'wsq-sci', bird.scientific_name));
    info.appendChild(head);

    if (bird.seasonality === 'migrant') {
      var seas = el('span', 'wsq-season-chip');
      seas.appendChild(el('i', 'ti ti-plane-tilt'));
      seas.appendChild(document.createTextNode(' Seasonal · ' + monthsLabel(bird.months)));
      /* badge on the photo, not in the card body — keeps migrant + resident card heights identical */
      illo.appendChild(seas);
    }

    var chips = el('div', 'wsq-chips');
    CHIPS.forEach(function (c) {
      var chip = el('span', 'wsq-chip');
      chip.appendChild(el('i', 'ti ' + c.icon));
      var val = bird.tiles[c.key] || '—';
      /* compact card shows only the first zone segment so all chips fit one row;
         the full "A · B" zone is still shown in the expanded ZONE tile */
      if (c.key === 'zone') val = String(val).split(' · ')[0];
      chip.appendChild(document.createTextNode(' ' + val));
      chips.appendChild(chip);
    });
    info.appendChild(chips);

    if (bird.confidence_score != null) {
      info.appendChild(confidenceEl(bird.confidence_score, bird.confidence_label, true));
    }

    var hint = el('span', 'wsq-expand-hint');
    hint.appendChild(el('i', 'ti ti-chevron-down'));
    hint.appendChild(document.createTextNode(' Tap for the full field card'));
    info.appendChild(hint);
    card.appendChild(info);

    /* hidden detail revealed on click */
    var detail = el('div', 'wsq-bird-detail');
    detail.appendChild(el('p', 'wsq-desc', bird.description));
    var tiles = el('div', 'wsq-tiles');
    TILES.forEach(function (def) { tiles.appendChild(tileEl(bird, def)); });
    detail.appendChild(tiles);
    detail.appendChild(challengeEl(bird.spotting_challenge));
    var cta = el('a', 'wsq-cta');
    cta.href = contactUrl;
    cta.appendChild(document.createTextNode('Plan your safari '));
    cta.appendChild(el('i', 'ti ti-arrow-right'));
    cta.addEventListener('click', function () {
      track('plan_safari', { cta_context: bird.common_name, bird_tab: bird.tab, cta_location: 'card' });
    });
    detail.appendChild(cta);
    card.appendChild(detail);

    function toggle(e) {
      if (e.target.closest('.wsq-cta')) return; /* let the CTA navigate */
      var open = card.classList.toggle('is-open');
      card.setAttribute('aria-expanded', open ? 'true' : 'false');
      var h = hint.querySelector('i');
      if (h) h.className = open ? 'ti ti-chevron-up' : 'ti ti-chevron-down';
      hint.lastChild.textContent = open ? ' Close field card' : ' Tap for the full field card';
      if (open) track('bird_open', {
        bird_name: bird.common_name, bird_sci: bird.scientific_name, bird_tab: bird.tab,
        bird_rarity: (bird.tiles && bird.tiles.rarity) || '', bird_confidence: bird.confidence_score || 0,
        bird_seasonality: bird.seasonality || 'resident'
      });
    }
    card.addEventListener('click', toggle);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(e); }
    });
    return card;
  }

  function challengeEl(level) {
    level = Math.max(1, Math.min(5, level || 1));
    var wrap = el('div', 'wsq-challenge');
    wrap.appendChild(el('span', 'wsq-challenge-label', 'Spotting challenge'));
    var dots = el('div', 'wsq-dots');
    for (var i = 1; i <= 5; i++) {
      dots.appendChild(el('span', 'wsq-dot' + (i <= level ? ' filled' : '')));
    }
    wrap.appendChild(dots);
    wrap.appendChild(el('span', 'wsq-challenge-text', CHALLENGE[level] + ' · ' + level + ' of 5'));
    return wrap;
  }

  /* ---------- Filtering (tab AND month) ---------- */
  function applyFilters(tab, month, grid, countEl, q) {
    var shown = 0, seasonalShown = 0;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.wsq-bird-card'));
    var matched = [];
    cards.forEach(function (c) {
      var tabOk = tab === 'all' || c.getAttribute('data-tab') === tab;
      var ms = (c.getAttribute('data-months') || '').split(',').filter(Boolean).map(Number);
      var monthOk = !month || !ms.length || ms.indexOf(month) !== -1;
      var qOk = !q || (c.getAttribute('data-name') || '').indexOf(q) !== -1;
      var match = tabOk && monthOk && qOk;
      var isSeasonalNow = month && c.getAttribute('data-seasonal') === '1' && ms.indexOf(month) !== -1;
      c.classList.toggle('is-seasonal-now', !!isSeasonalNow);
      if (match) { matched.push(c); shown++; if (isSeasonalNow) seasonalShown++; }
      else { c.style.display = 'none'; c.classList.remove('is-open'); c.setAttribute('aria-expanded', 'false'); }
    });
    /* when a month is picked, float that month's seasonal birds to the top */
    if (month) {
      matched.sort(function (a, b) {
        var as = a.classList.contains('is-seasonal-now') ? 0 : 1;
        var bs = b.classList.contains('is-seasonal-now') ? 0 : 1;
        if (as !== bs) return as - bs;
        return Number(a.getAttribute('data-order')) - Number(b.getAttribute('data-order'));
      });
    } else {
      matched.sort(function (a, b) { return Number(a.getAttribute('data-order')) - Number(b.getAttribute('data-order')); });
    }
    /* reorder matched to the front, then paginate: only the first visibleLimit are shown */
    matched.forEach(function (c, i) { grid.appendChild(c); c.style.display = (i < visibleLimit) ? '' : 'none'; });
    lastMatched = shown;
    if (countEl) {
      if (shown === 0) {
        countEl.textContent = q ? 'No birds match “' + q + '” — try a different name or clear the search'
                                 : 'No birds match these filters';
      } else {
        var vis = Math.min(shown, visibleLimit);
        countEl.textContent = (vis < shown ? 'Showing ' + vis + ' of ' + shown : shown + ' species')
          + (month ? ' in ' + MON[month] : '')
          + (seasonalShown ? ' · ' + seasonalShown + ' seasonal' : '');
      }
    }
    syncLoadMore(shown);
  }

  /* ---------- Form ---------- */
  function wireForm() {
    var form = root.querySelector('.wsq-form');
    if (!form) return;
    var msg = root.querySelector('.wsq-form-msg');
    var endpoint = root.getAttribute('data-sightings-endpoint');
    var submitBtn = form.querySelector('[type="submit"]');
    var val = function (n) { var f = form.querySelector('[name="' + n + '"]'); return f ? f.value.trim() : ''; };

    function finish() {
      if (msg) {
        msg.textContent = 'Thanks! Your sighting has been sent for review — it will appear once approved.';
        msg.classList.add('is-shown');
      }
      form.reset();
      if (submitBtn) submitBtn.disabled = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ok = true;
      form.querySelectorAll('[required]').forEach(function (f) {
        if (!f.value.trim()) { f.classList.add('wsq-form-error'); ok = false; }
        else f.classList.remove('wsq-form-error');
      });
      if (!ok) return;

      track('sighting_submit', { sighting_location: val('location'), has_photo: val('photo') ? 'yes' : 'no' });

      var data = new URLSearchParams();
      data.append('name', val('name'));
      data.append('location', val('location'));
      data.append('sighting', val('sighting'));
      data.append('photo', val('photo'));
      data.append('source', window.location.pathname);

      if (submitBtn) submitBtn.disabled = true;
      if (endpoint) {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: data.toString()
        }).then(finish).catch(finish); /* moderated queue — confirm regardless */
      } else {
        finish();
      }
    });
    form.querySelectorAll('input, textarea').forEach(function (f) {
      f.addEventListener('input', function () { f.classList.remove('wsq-form-error'); });
    });
  }

  /* ---------- Featured card (re-rendered to track the active tab) ---------- */
  function buildFeatured(bird) {
    var frag = document.createDocumentFragment();
    var illo = el('div', 'wsq-featured-illo');
    illo.style.background = bird.card_colour || '#9FE1CB';
    if (bird.photo) {
      var img = document.createElement('img');
      img.className = 'wsq-featured-photo';
      img.src = bird.photo; img.alt = bird.common_name; img.loading = 'lazy';
      if (bird.photo_focus) img.style.objectPosition = bird.photo_focus;
      illo.appendChild(img);
      if (bird.photo_credit) illo.appendChild(el('span', 'wsq-photo-credit', bird.photo_credit));
    }
    frag.appendChild(illo);

    var body = el('div', 'wsq-featured-body');
    var head = el('div', 'wsq-featured-head');
    var nameWrap = el('div', 'wsq-featured-name');
    nameWrap.appendChild(el('h2', null, bird.common_name));
    nameWrap.appendChild(el('span', 'wsq-sci', bird.scientific_name));
    head.appendChild(nameWrap);
    body.appendChild(head);

    var taxa = el('dl', 'wsq-taxa');
    [['Order', bird.order], ['Family', bird.family], ['Group', bird.group]].forEach(function (kv) {
      var d = el('div'); d.appendChild(el('dt', null, kv[0])); d.appendChild(el('dd', null, kv[1])); taxa.appendChild(d);
    });
    body.appendChild(taxa);

    var when = el('div', 'wsq-featured-when');
    when.appendChild(el('span', 'wsq-when-label', 'When'));
    when.appendChild(seasonStrip(bird.months));
    when.appendChild(el('span', 'wsq-when-text', monthsLabel(bird.months)));
    body.appendChild(when);

    var tiles = el('div', 'wsq-tiles');
    TILES.forEach(function (def) { tiles.appendChild(tileEl(bird, def)); });
    body.appendChild(tiles);

    var foot = el('div', 'wsq-featured-foot');
    foot.appendChild(el('p', 'wsq-desc', bird.description));
    if (bird.confidence_score != null) foot.appendChild(confidenceEl(bird.confidence_score, bird.confidence_label, false));
    var cta = el('a', 'wsq-cta');
    cta.href = contactUrl;
    cta.appendChild(document.createTextNode('Plan your safari '));
    cta.appendChild(el('i', 'ti ti-arrow-right'));
    cta.addEventListener('click', function () {
      track('plan_safari', { cta_context: bird.common_name, bird_tab: bird.tab, cta_location: 'featured' });
    });
    foot.appendChild(cta);
    body.appendChild(foot);
    frag.appendChild(body);
    return frag;
  }
  function setFeatured(bird) {
    var fc = root.querySelector('.wsq-featured');
    if (!fc || !bird) return;
    while (fc.firstChild) fc.removeChild(fc.firstChild);
    fc.appendChild(buildFeatured(bird));
  }

  /* ---------- Boot ---------- */
  function boot(data) {
    var grid = root.querySelector('.wsq-grid');
    var countEl = root.querySelector('.wsq-count');
    var species = (data && data.species) || [];
    var featuredId = (data && data.featured) || (species[0] && species[0].id);
    if (grid) species.forEach(function (b, i) { grid.appendChild(birdCard(b, i)); });

    var state = { tab: 'all', month: 0, q: '' };

    function byConf(a, b) { return (b.confidence_score || 0) - (a.confidence_score || 0); }
    function seasonFirst(month) {
      return function (a, b) {
        var as = (a.seasonality === 'migrant' && inMonth(a, month)) ? 0 : 1;
        var bs = (b.seasonality === 'migrant' && inMonth(b, month)) ? 0 : 1;
        if (as !== bs) return as - bs;
        return byConf(a, b);
      };
    }
    /* Precompute a DISTINCT hero per (tab × month). Greedy: each month takes the top
       in-season bird OF THAT TAB not yet used (that month's migrants ranked first); when a
       tab's pool is exhausted the cycle resets (small tabs like Nocturnal have <12 birds,
       so some repeats across the year are unavoidable — but they stay maximally spread). */
    var TABS = ['all', 'raptors', 'waterbirds', 'savanna', 'nocturnal'];
    var heroByTabMonth = {};
    TABS.forEach(function (tab) {
      var poolAll = (tab === 'all') ? species : species.filter(function (b) { return b.tab === tab; });
      var used = {}, byMonth = {};
      for (var m = 1; m <= 12; m++) {
        var cands = poolAll.filter(function (b) { return inMonth(b, m); }).sort(seasonFirst(m));
        var pick = null;
        for (var i = 0; i < cands.length; i++) { if (!used[cands[i].id]) { pick = cands[i]; break; } }
        if (!pick && cands.length) { used = {}; pick = cands[0]; } /* pool exhausted → new cycle */
        if (pick) { used[pick.id] = 1; byMonth[m] = pick; }
      }
      heroByTabMonth[tab] = byMonth;
    });

    function pickFeatured() {
      if (!state.month) {
        if (state.tab === 'all') {
          var f = species.filter(function (b) { return b.id === featuredId; })[0];
          if (f) return f;
        }
        var p0 = species.filter(function (b) { return state.tab === 'all' || b.tab === state.tab; });
        return (p0.length ? p0 : species).slice().sort(byConf)[0];
      }
      var byMonth = heroByTabMonth[state.tab] || heroByTabMonth['all'];
      var h = byMonth && byMonth[state.month];
      if (h) return h;
      var present = species.filter(function (b) { return (state.tab === 'all' || b.tab === state.tab) && inMonth(b, state.month); });
      return (present.length ? present : species).slice().sort(seasonFirst(state.month))[0];
    }

    /* month selector + season note, built in JS and inserted after the tabs */
    var noteEl = el('p', 'wsq-month-note');
    var tabsNav = root.querySelector('.wsq-tabs');
    var monthsNav = el('div', 'wsq-months');
    monthsNav.appendChild(el('span', 'wsq-months-label', 'Travelling in'));
    function mkChip(m, text) {
      var b = el('button', 'wsq-month' + (m === 0 ? ' is-active' : ''), text);
      b.type = 'button';
      b.addEventListener('click', function () {
        monthsNav.querySelectorAll('.wsq-month').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        state.month = m;
        refresh();
        track('filter_month', { filter_month: m ? MON[m] : 'any', filter_tab: state.tab });
      });
      return b;
    }
    monthsNav.appendChild(mkChip(0, 'Any month'));
    for (var m = 1; m <= 12; m++) monthsNav.appendChild(mkChip(m, MON[m]));
    if (tabsNav && tabsNav.parentNode) {
      tabsNav.parentNode.insertBefore(monthsNav, tabsNav.nextSibling);
      tabsNav.parentNode.insertBefore(noteEl, monthsNav.nextSibling);
    }

    /* name search — filters the grid by common + scientific name */
    var searchWrap = el('div', 'wsq-search');
    searchWrap.appendChild(el('i', 'ti ti-search'));
    var searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.className = 'wsq-search-input';
    searchInput.placeholder = 'Search by name…';
    searchInput.setAttribute('aria-label', 'Search birds by name');
    searchWrap.appendChild(searchInput);
    if (grid && grid.parentNode) grid.parentNode.insertBefore(searchWrap, grid);

    /* "Load more" pagination button — inserted right after the grid */
    loadMoreEl = el('button', 'wsq-load-more');
    loadMoreEl.type = 'button';
    loadMoreEl.style.display = 'none';
    if (grid && grid.parentNode) grid.parentNode.insertBefore(loadMoreEl, grid.nextSibling);
    loadMoreEl.addEventListener('click', function () {
      visibleLimit += PAGE_SIZE;
      applyFilters(state.tab, state.month, grid, countEl, state.q);
      track('load_more', { visible: visibleLimit, filter_tab: state.tab });
    });

    /* analytics: log each settled search to GA4 (debounced, deduped). search_term + results_count
       (incl. ZERO-result = birds visitors want that we don't have) + the active tab/month context +
       the top match they actually saw. See track() at the top for the delivery mechanism. */
    var searchTimer = null, lastLogged = '';
    function logSearch() {
      var q = state.q;
      if (!q || q.length < 2 || q === lastLogged) return;
      lastLogged = q;
      var n = lastMatched, first = '', cards = grid.querySelectorAll('.wsq-bird-card');
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].style.display !== 'none') { var h3 = cards[i].querySelector('h3'); first = h3 ? h3.textContent : ''; break; }
      }
      track('search', {
        search_term: q, results_count: n, top_result: first,
        filter_tab: state.tab, filter_month: state.month ? MON[state.month] : 'any'
      });
    }
    searchInput.addEventListener('input', function () {
      state.q = searchInput.value.toLowerCase().trim();
      refresh();
      clearTimeout(searchTimer);
      searchTimer = setTimeout(logSearch, 900); /* fire ~0.9s after they stop typing */
    });

    function refresh() {
      visibleLimit = PAGE_SIZE;
      applyFilters(state.tab, state.month, grid, countEl, state.q);
      var fb = pickFeatured();
      if (fb) setFeatured(fb);
      if (state.month) { noteEl.textContent = MONTH_NOTES[state.month] || ''; noteEl.classList.add('is-shown'); }
      else { noteEl.textContent = ''; noteEl.classList.remove('is-shown'); }
    }

    var tabs = root.querySelectorAll('.wsq-tab');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        state.tab = t.getAttribute('data-tab');
        refresh();
        track('filter_tab', { filter_tab: state.tab, filter_month: state.month ? MON[state.month] : 'any' });
      });
    });

    refresh();
    wireForm();
  }

  if (dataUrl) {
    fetch(dataUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(boot)
      .catch(function () { boot({ species: [] }); wireForm(); });
  } else {
    boot({ species: [] });
  }
})();
